const API_BASE = process.env.REACT_APP_API_URL;
const PERMISOS_URL = `${API_BASE}Permisos`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export async function getPermisos() {
  const res = await fetch(PERMISOS_URL, {
    headers: getAuthHeaders()
  });
  return await res.json();
}

export async function createPermiso(values) {
  try {
    await fetch(PERMISOS_URL, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        nombre: values.nombre,
        descripcion: values.descripcion,
        estado: Number(values.estado)
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function editPermiso(id, values) {
  try {
    await fetch(`${PERMISOS_URL}/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        nombre: values.nombre,
        descripcion: values.descripcion,
        estado: Number(values.estado)
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function deletePermiso(id) {
  try {
    await fetch(`${PERMISOS_URL}/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return true;
  } catch {
    return false;
  }
}
